import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EditEngagementMemoryServiceService {

  private engagementId: number;
  private selectedlanguages: any[];
  private engagementRoles = [];
  private languages = [];
  private internalContacts = [];
  private externalRoles = [];
  private externalContacts = [];
  private selectedFolderTemplate: string;
  private jurisdiction = [];

  private engagementDetails: EngagementDetails;

  constructor() { }

  setSelectedLanguages(selectedLanguages) {
    this.selectedlanguages = selectedLanguages;
  }
  getSelectedLanguages() {
    return this.selectedlanguages;
  }
  setLanguages(languages: []) {
    this.languages = languages;
  }
  getLanguages(): any[] {
    return this.languages;
  }
  setEngagementRoles(engagementRoles: []) {
    this.engagementRoles = engagementRoles;
  }
  getLanguageBasedRoles(): any[] {
    return this.engagementRoles;
  }
  setEngagementDetails(initalDate: Date, isPrivate: boolean, shortUrl: string, isConfidential: boolean, languageBasedDetails: any, urlDomain: string, eyRole: any, juridiction: any) {
    this.engagementDetails = new EngagementDetails(initalDate, isPrivate, shortUrl, isConfidential, languageBasedDetails, urlDomain, eyRole, juridiction);
  }
  getEngagementDetails() {
    return this.engagementDetails;
  }
  setContactDetails(internalContacts: any[], externalRoles: any[], externalContacts: any[]) {
    this.internalContacts = internalContacts;
    this.externalRoles = externalRoles;
    this.externalContacts = externalContacts;
  }
  getInteralContact(): any[] {
    return this.internalContacts;
  }
  getExternalRole(): any[] {
    return this.externalRoles;
  }
  getExternalContacts(): any[] {
    return this.externalContacts;
  }

  setFolderTemplate(selectedFolder) {
    this.selectedFolderTemplate = JSON.stringify(selectedFolder);
  }

  getFolderTemplate(): any {
    return this.selectedFolderTemplate;
  }

  setEngagementId(engagementId: number) {
    this.engagementId = engagementId;
  }

  getEngagementId(): number {
    return this.engagementId;
  }

  resetEngagementMemory() {
    this.selectedlanguages = [];
    this.engagementDetails = null;
    this.internalContacts = [];
    this.externalContacts = [];
    this.externalRoles = [];
    this.selectedFolderTemplate = "";

  }

  setJurisdictionOption(jurisdictionOptions) {
    this.jurisdiction = jurisdictionOptions;
  }

  getJurisdictionOption(): any {
    return this.jurisdiction;
  }

  addSelectedLanguage(languageModel: any) {
    this.selectedlanguages.push(languageModel);
  }
}

export class EngagementDetails {
  initalDate: Date;
  isPrivate: boolean;
  shortUrl: string;
  isConfidential: boolean;
  languageBasedDetails: any;
  urlDomain: string;
  eyRole: any;
  jurisdiction: any;
  constructor(initalDate: Date, isPrivate: boolean, shortUrl: string, isConfidential: boolean, languageBasedDetails: any, urlDomain: string, eyRole, jurisdiction) {
    this.initalDate = initalDate;
    this.isPrivate = isPrivate;
    this.shortUrl = shortUrl;
    this.isConfidential = isConfidential;
    this.languageBasedDetails = languageBasedDetails;
    this.urlDomain = urlDomain;
    this.eyRole = eyRole;
    this.jurisdiction = jurisdiction;
  }
}
